import { useState, useRef, useEffect } from "react";
import silverLogo from "../../assets/silverRateWork.png";
import html2pdf from "html2pdf.js";
import { useLocation } from "react-router-dom";

export default function KWGoldReport() {
  const [form, setForm] = useState({
    reportDate: "",
    reportSerial: "",
    clientName: "",
    clientAddress: "",
    clientNumber: "",
    dateReceived: "",
    reportNumber: "",
    weight: "",
    silverPct: "",
    platinumPct: "",
    palladiumPct: "",
    purityKg: "",
  });
  const { search } = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(search);
    const data = queryParams.get("data");

    if (data) {
      const customerData = JSON.parse(decodeURIComponent(data));
      console.log({ reportDate: customerData?.reportDate });
      if (customerData) {
        const reportDate = customerData?.reportDate
          ? new Date(customerData.reportDate).toISOString().split("T")[0]
          : new Date().toISOString().split("T")[0];
        setForm({
          ...form,
          reportSerial: customerData?.serialNumber,
          clientName: customerData?.customer?.customerName,
          clientAddress: customerData?.customer?.customerAddress,
          clientNumber: customerData?.customer?.customerContact,
          reportNumber: customerData?.lab?.report,
          weight: customerData?.lab?.weight,
          silverPct: customerData?.lab?.pureWeight,
          reportDate,
          // platinumPct: "",
          // palladiumPct: "",
          // purityKg: "",
        });
      }
    }
  }, [search]);

  console.log("Form data:", form.reportDate);

  const pageRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handlePrint = () => window.print();

  const handlePDF = async () => {
    const options = {
      margin: 0,
      filename: `KW_Gold_Report_${form.reportSerial || "001"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(options).from(pageRef.current).save();
  };

  return (
    <>
      <style>{styles}</style>
      <div className="kw-body">
        <div className="report-page" ref={pageRef}>
          {/* HEADER */}
          <div className="header">
            <div className="header-left">
              <div className="company-name">
                KW<sup style={{ fontSize: "22px" }}>TM</sup>
              </div>
              <div className="company-tagline">
                Gold &amp; Silver Testing Laboratory
              </div>
            </div>
            <div className="header-center">
              <img
                src={silverLogo}
                alt="KW Logo"
                className="logo"
                style={{
                  width: "100px",
                  height: "75px",
                  marginTop: "-20px",
                }}
              />
            </div>
            {/* <div className="header-center">
              <div className="logo-circle">
                <span>
                  KW<sup style={{ fontSize: "10px" }}>TM</sup>
                </span>
                <span className="logo-circle-sub">
                  GOLD &amp; SILVER
                  <br />
                  LAB
                </span>
              </div>
            </div> */}
            <div className="header-right">
              <div className="urdu-text">کے ڈبلیو</div>
              <div className="urdu-tagline">گولڈ اینڈ سلور ٹیسٹنگ لیبارٹری</div>
            </div>
          </div>

          {/* TOP INFO */}
          <div className="top-info">
            <span>
              DATE:{" "}
              <input
                type="date"
                name="reportDate"
                value={form.reportDate}
                onChange={handleChange}
              />
            </span>
            <span>
              SERIAL NO:
              <input
                type="text"
                name="reportSerial"
                value={form.reportSerial}
                onChange={handleChange}
                style={{ width: 140 }}
                placeholder="Enter serial"
              />
            </span>
          </div>

          {/* REPORT TITLE */}
          <div className="report-title">Gold Testing Report</div>

          {/* MAIN CONTENT ROW 1 */}
          <div className="main-content">
            {/* Client */}
            <div className="client-section">
              <div className="section-title">Client</div>
              <div className="field-row">
                <div className="field-label">Name:</div>
                <input
                  className="field-value"
                  type="text"
                  name="clientName"
                  value={form.clientName}
                  onChange={handleChange}
                  placeholder="Enter client name"
                />
              </div>
              {form.clientAddress && (
                <div className="field-row">
                  <div className="field-label">Address:</div>
                  <input
                    className="field-value"
                    type="text"
                    name="clientAddress"
                    value={form.clientAddress}
                    onChange={handleChange}
                    placeholder="Enter address"
                  />
                </div>
              )}
              <div className="field-row">
                <div className="field-label">Number:</div>
                <input
                  className="field-value"
                  type="text"
                  name="clientNumber"
                  value={form.clientNumber}
                  onChange={handleChange}
                  placeholder="Enter client number"
                />
              </div>
            </div>

            {/* Sample Identification */}
            <div className="sample-section">
              <div className="section-title">Sample Identification</div>
              {/* <div className="field-row">
                <div className="field-label">Date Received:</div>
                <input
                  className="field-value"
                  type="date"
                  name="dateReceived"
                  value={form.dateReceived}
                  onChange={handleChange}
                />
              </div> */}
              <div className="company-info-box">
                <div className="kw-logo-small">
                  KW<sup>TM</sup>
                </div>
                <div style={{ fontWeight: "bold", fontSize: "10px" }}>
                  Gold &amp; Silver Testing Laboratory
                </div>
                <div>TEL: 021-34806318, 021-34856018, 021-3685037</div>
                <div>MOBILE: 0333-3188888</div>
              </div>
            </div>
          </div>

          {/* MAIN CONTENT ROW 2 */}
          <div className="main-content">
            <div className="client-section">
              <div className="field-row">
                <div className="field-label">Report:</div>
                <input
                  className="field-value"
                  type="text"
                  name="reportNumber"
                  value={form.reportNumber}
                  onChange={handleChange}
                  placeholder="Enter report number"
                />
              </div>
              <div className="field-row">
                <div className="field-label">Weight:</div>
                <input
                  className="field-value"
                  type="number"
                  name="weight"
                  value={form.weight}
                  onChange={handleChange}
                  placeholder="Enter weight"
                  step="0.01"
                />
              </div>
              <div className="field-row">
                <div className="field-label">Pure Weight:</div>
                <input
                  className="field-value"
                  type="number"
                  name="silverPct"
                  value={form.silverPct}
                  onChange={handleChange}
                  placeholder="xxxxx"
                  step="0.01"
                />
              </div>
              {/* <div className="field-row">
                <div className="field-label">Platinum PT.%:</div>
                <input
                  className="field-value"
                  type="number"
                  name="platinumPct"
                  value={form.platinumPct}
                  onChange={handleChange}
                  placeholder="xxxxx"
                  step="0.01"
                />
              </div>
              <div className="field-row">
                <div className="field-label">Palladium PD.%:</div>
                <input
                  className="field-value"
                  type="number"
                  name="palladiumPct"
                  value={form.palladiumPct}
                  onChange={handleChange}
                  placeholder="xxxxx"
                  step="0.01"
                />
              </div>
              <div className="field-row">
                <div className="field-label">Purity / KG:</div>
                <input
                  className="field-value"
                  type="text"
                  name="purityKg"
                  value={form.purityKg}
                  onChange={handleChange}
                  placeholder="xxxxx"
                />
              </div> */}
            </div>

            <div className="sample-section">
              <div className="right-card">
                <div className="card-title">
                  KW<sup>TM</sup>
                  <div className="card-sub">
                    Gold &amp; Silver Testing Laboratory
                  </div>
                </div>
                <div className="card-row">
                  SERIAL NO: {form.reportSerial || " "}
                </div>
                <div className="card-row">TEL NO: 021-34806318</div>
                <div className="card-row">MOBILE: 0333-3188888</div>
                <div className="card-box">
                  <div className="box-cell"></div>
                  <div className="box-cell"></div>
                </div>
              </div>
              <div className="disclaimer">
                We are not responsible if the Gold is not taken back.
                <span className="disclaimer-urdu">
                  اگر سونا واپس نہیں لیا جاتا تو ہم اس کے ذمہ دار نہیں ہیں
                </span>
                KW Lab is not responsible for this analysis
              </div>
            </div>
          </div>

          {/* LAB USE ONLY */}
          <div className="lab-use-only">LAB USE ONLY</div>

          {/* TEST METHOD */}
          <div className="test-method">
            <div className="method-box">
              <div className="method-title">TEST METHOD NAME</div>
              <div className="method-name">GOLD ALLOYS DETERMINATION</div>
            </div>
            <div className="method-box">
              <div className="method-title">ANALYTICAL METHOD USED</div>
              <div className="method-name">
                FIRE ASSAY / AQUA REGIA DEGESTION
              </div>
            </div>
          </div>

          {/* TESTED BY */}
          <div className="tested-by">
            <div className="tested-box">
              <div className="tested-title">TESTED BY</div>
              <div className="tested-name">عَبْدُ الصَّمَدِ الرَّحْمَانِيّ</div>
            </div>
            <div className="ceo-box">
              <div className="ceo-title">
                KW<sup style={{ fontSize: "12px" }}>TM</sup>
              </div>
              <div className="ceo-subtitle">GOLD &amp; SILVER LABORATORY</div>
              <div className="ceo-subtitle">CEO</div>
            </div>
          </div>

          {/* FOOTER */}
          <div className="footer">
            "Thank you for your trust in KW Gold &amp; Silver Testing
            Laboratory"
          </div>
        </div>

        {/* BUTTONS */}
        <div className="button-container">
          <button className="btn-pdf" onClick={handlePDF}>
            📄 PDF
          </button>
          <button className="btn-print" onClick={handlePrint}>
            🖨️ Print
          </button>
        </div>
      </div>
    </>
  );
}

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Amiri:ital,wght@0,400;0,700;1,400&family=Cinzel:wght@400;600;700&family=Noto+Nastaliq+Urdu&display=swap');

  * { margin: 0; padding: 0; box-sizing: border-box; }

  .kw-body {
    font-family: 'Cinzel', serif;
    background: #f0ece4;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
  }

  .report-page {
    width: 210mm;
    min-height: 200mm;
    background: white;
    padding: 16mm 18mm;
    box-shadow: 0 0 30px rgba(0,0,0,0.15);
    position: relative;
  }

  /* HEADER */
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 3px solid #c9882b;
    padding-bottom: 12px;
    margin-bottom: 16px;
  }
  .header-left { flex: 1; text-align: left; }
  .header-center { flex: 0 0 auto; padding: 0 16px; display:flex; align-items:center; }
  .header-right { flex: 1; text-align: right; direction: rtl; }

  .company-name { font-size: 42px; font-weight: 700; color: #c9882b; line-height: 1; }
  .company-tagline { font-size: 13px; color: #666; font-family: Arial, sans-serif; margin-top: 4px; }
  .urdu-text { font-family: 'Noto Nastaliq Urdu', serif; font-size: 28px; color: #c9882b; font-weight: 700; direction: rtl; }
  .urdu-tagline { font-family: 'Noto Nastaliq Urdu', serif; font-size: 14px; color: #666; direction: rtl; }

  .logo-circle {
    width: 90px; height: 90px;
    border: 3px solid #c9882b;
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-size: 22px; font-weight: 700; color: #c9882b;
    background: #fff9f1;
    flex-direction: column;
    text-align: center;
    line-height: 1.2;
  }
  .logo-circle-sub { font-size: 8px; font-family: Arial; color: #888; margin-top: 2px; }

  /* TOP INFO */
  .top-info {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    font-size: 11px;
    font-family: Arial, sans-serif;
    color: #555;
  }
  .top-info input {
    height: 24px;
    border: none;
    border-bottom: 1px solid #999;
    padding: 2px 4px;
    font-size: 11px;
    font-family: Arial, sans-serif;
    outline: none;
    background: transparent;
    color: #333;
  }

  /* REPORT TITLE */
  .report-title {
    background: linear-gradient(to right, #c9882b, #e8b96a);
    color: white;
    text-align: center;
    padding: 9px;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 16px;
    letter-spacing: 2px;
  }

  /* MAIN CONTENT GRID */
  .main-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;
  }

  .client-section, .sample-section {
    border: 2px solid #c9882b;
    padding: 12px;
  }

  .section-title {
    background: #c9882b;
    color: white;
    text-align: center;
    padding: 6px;
    font-size: 13px;
    font-weight: 700;
    margin: -12px -12px 12px -12px;
    letter-spacing: 1px;
  }

  .field-row {
    display: flex;
    margin-bottom: 8px;
    font-size: 11px;
    align-items: center;
    font-family: Arial, sans-serif;
  }
  .field-label { width: 100px; color: #333; font-weight: 600; font-size: 11px; }
  .field-value {
    flex: 1;
    height: 25px;
    border: 1.5px solid #c9882b;
    border-radius: 2px;
    padding: 0px 6px;
    font-size: 11px;
    font-family: Arial, sans-serif;
    outline: none;
    color: #333;
  }
  .field-value:focus { border-color: #e8b96a; box-shadow: 0 0 4px rgba(201,136,43,0.25); }

  /* Company info box */
  .company-info-box {
    margin-top: 12px;
    padding: 8px;
    border: 1px solid #ddd;
    font-size: 9px;
    line-height: 1.7;
    font-family: Arial, sans-serif;
    color: #444;
  }
  .kw-logo-small { font-size: 15px; font-weight: 700; color: #c9882b; margin-bottom: 3px; font-family: 'Cinzel', serif; }

  /* RIGHT CARD */
  .right-card {
    width: 175px;
    border: 2px solid #c9882b;
    padding: 8px;
    margin-top: 6px;
    background: #fff9f1;
    font-size: 10px;
    font-family: Arial, sans-serif;
  }
  .card-title { font-weight: 700; color: #c9882b; margin-bottom: 5px; font-family: 'Cinzel', serif; font-size: 11px; }
  .card-sub { font-size: 9px; font-weight: 400; color: #666; font-family: Arial, sans-serif; }
  .card-row { margin-bottom: 3px; color: #444; }
  .card-box { display: flex; gap: 5px; margin-top: 5px; }
  .box-cell { flex: 1; height: 32px; border: 1px solid #ddd; background: #fff; }

  /* DISCLAIMER */
  .disclaimer {
    background: #f9f9f9;
    border: 1px solid #ddd;
    padding: 10px;
    margin-top: 12px;
    font-size: 9px;
    text-align: center;
    color: #666;
    line-height: 1.6;
    font-family: Arial, sans-serif;
  }
  .disclaimer-urdu { font-family: 'Noto Nastaliq Urdu', serif; direction: rtl; display: block; font-size: 10px; margin: 3px 0; }

  /* LAB USE ONLY */
  .lab-use-only {
    background: #c9882b;
    color: white;
    text-align: center;
    padding: 7px;
    font-size: 13px;
    font-weight: 700;
    margin: 16px 0;
    letter-spacing: 2px;
  }

  /* TEST METHOD */
  .test-method {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;
  }
  .method-box { border: 2px solid #c9882b; padding: 12px; }
  .method-title { font-size: 10px; color: #888; margin-bottom: 4px; font-family: Arial, sans-serif; }
  .method-name { font-size: 12px; color: #c9882b; font-weight: 700; letter-spacing: 0.5px; }

  /* TESTED BY */
  .tested-by {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;
  }
  .tested-box { border: 2px solid #c9882b; padding: 12px; }
  .tested-title { font-size: 10px; color: #888; margin-bottom: 4px; font-family: Arial, sans-serif; }
  .tested-name { font-size: 15px; color: #c9882b; font-weight: 700; font-family: 'Amiri', serif; }
  .ceo-box { text-align: right; display: flex; flex-direction: column; justify-content: flex-end; padding-bottom: 4px; }
  .ceo-title { font-size: 18px; font-weight: 700; color: #c9882b; }
  .ceo-subtitle { font-size: 10px; color: #666; font-family: Arial, sans-serif; }

  /* FOOTER */
  .footer {
    text-align: center;
    font-size: 11px;
    color: #c9882b;
    font-style: italic;
    margin-top: 20px;
    padding: 12px;
    border-top: 2px solid #c9882b;
    border-bottom: 2px solid #c9882b;
    font-family: 'Amiri', serif;
  }

  /* BUTTONS */
  .button-container {
    display: flex;
    justify-content: space-between;
    width: 210mm;
    margin-top: 16px;
    margin-bottom: 20px;
    padding: 16px 20px;
    gap: 16px;
    background: #f9f9f9;
    border-radius: 6px;
  }
  .btn-pdf, .btn-print {
    padding: 10px 28px;
    font-size: 13px;
    font-weight: 700;
    border: 2px solid #c9882b;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.25s ease;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-family: 'Cinzel', serif;
  }
  .btn-pdf { background: white; color: #c9882b; }
  .btn-pdf:hover { background: #c9882b; color: white; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(201,136,43,0.3); }
  .btn-print { background: #c9882b; color: white; }
  .btn-print:hover { background: #b57d1f; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(201,136,43,0.3); }
  .btn-pdf:active, .btn-print:active { transform: translateY(0); }

  @media print {
    .button-container { display: none; }
    .kw-body { background: white; padding: 0; }
    .report-page { box-shadow: none; margin: 0; }
  }
`;

// const html2pdf = (
//   await import("https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js")
// ).default;
// html2pdf()
//   .set({
//     margin: 0,
//     filename: `KW_Gold_Report_${form.reportSerial || "001"}.pdf`,
//     image: { type: "jpeg", quality: 0.98 },
//     html2canvas: { scale: 2, useCORS: true },
//     jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
//   })
//   .from(pageRef.current)
//   .save();
